import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  Outlet,
  RouterProvider,
  ScrollRestoration,
  createBrowserRouter,
} from "react-router-dom";

import NotFound from "./screens/404";
import StartScan from "./screens/StartScan";
import BasicDetails from "./screens/BasicDetails";
import SelectScanType from "./screens/SelectScanType";
import SelectPosture from "./screens/SelectPosture";
import ScanInstructions from "./screens/ScanInstructions";
import FaceScan from "./screens/FaceScan";
import FingerScan from "./screens/FingerScan";
import ScanResult from "./screens/ScanResult";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <ScrollRestoration />
        <Outlet />
      </>
    ),
    children: [
      { index: true, element: <NotFound /> },
      { path: "start-scan", element: <StartScan /> },
      { path: "basic-details", element: <BasicDetails /> },
      { path: "select-scan-type", element: <SelectScanType /> },
      { path: "select-posture", element: <SelectPosture /> },
      { path: "scan-instructions", element: <ScanInstructions /> },
      { path: "face-scan", element: <FaceScan /> },
      { path: "finger-scan", element: <FingerScan /> },
      { path: "scan-result", element: <ScanResult /> },
      { path: "*", element: <NotFound /> },
    ],
    errorElement: <NotFound />,
  },
]);

const App = () => {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (typeof i18n.resolvedLanguage === "string") {
      document.documentElement.lang = i18n.resolvedLanguage;
      document.documentElement.dir = i18n.dir(i18n.resolvedLanguage);
    }
  }, [i18n, i18n.resolvedLanguage]);
  return <RouterProvider router={router} />;
};

export default App;
